// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__3Hap9","bg_blue":"Sidebar_bg_blue__VhLKN","logo":"Sidebar_logo__GWAET","header":"Sidebar_header__1ycWD","desktopFirstHeader":"Sidebar_desktopFirstHeader__3tzMf","secondHeader":"Sidebar_secondHeader__3ov_N","firstHeader":"Sidebar_firstHeader__1kDGd","message":"Sidebar_message__pbmes"};
    if(module.hot) {
      // 1741870133738
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  